import { Link } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { makeStyles } from "@mui/styles";
import React from 'react';
const useStyles = makeStyles(theme => ({

    root: {
        backgroundColor: '#18042e !important',
    },
    link: {
        marginTop: '10px !important',
        color: '#fc03d3 !important',
        textDecoration: 'none !important',
        
    }
}));
export default function BlogDetails({ item }) {
    const classes = useStyles();
    return (
        // <Grid item sm={12} md={6} lg={3}>
        <Card className={classes.root}>
            <CardMedia
                component="img"
                height="200"
                image={item.img}
                alt="green iguana"
            />
            <CardContent>
                <Typography color="#fff" variant="h6" sx={{margin: '0 0 10px 0'}}>
                    {item.title}
                </Typography>
                <Typography variant="body2" color="#bfb6be" >
                    {item.description}
                </Typography>
                <Link href={item.blog} className={classes.link} target={"_blank"} style={{marginTop: '10px'}}>{item.goLink}</Link>
            </CardContent>
        </Card>
        // </Grid>
    )
}
